import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CandidateMeetingModel, InterviewDashboardResult } from "../../../interviews.models";
import { DateService } from "src/app/services/date.service";

@Component({
    selector: 'interview-dashboard-card-pending',
    templateUrl: './interview-dashboard-card-pending.component.html',
    standalone: false
})
export class InterviewDashboardCardPendingComponent {
  @Input() meeting?: CandidateMeetingModel;
  @Input() dashboardInfo: InterviewDashboardResult | null = null;

  @Output() onViewDetailsClick: EventEmitter<CandidateMeetingModel> = new EventEmitter();

  constructor(public dateService:DateService) {
  }

  public viewDetails(){
    this.onViewDetailsClick.emit(this.meeting!);
  }
}
